import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

/**Local file */

import { apiCalls } from '../../utils/index';
import { CommonQueryService } from '../../queryFiles';

@Injectable()
export class EcommerceOrderService implements Resolve<any>
{
    apiCalls = apiCalls;
    order: any;
    onOrderChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private http: HttpClient,
        public commonQueryService: CommonQueryService,
    ) {
    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return new Promise<void>((resolve, reject) => {

            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    //get single order
    getOrder(id) {
        return new Promise((resolve, reject) => {
            this.commonQueryService.FETCH_ORDER_BY_ID(id).valueChanges.subscribe((singleOrderRes) => {
                if (singleOrderRes && singleOrderRes.data && singleOrderRes.data.allOrders
                    && singleOrderRes.data.allOrders.nodes.length > 0 && singleOrderRes.data.allOrders.nodes[0]) {
                    var responseResult = singleOrderRes.data.allOrders.nodes[0].orderContent ?
                        JSON.parse(singleOrderRes.data.allOrders.nodes[0].orderContent) : null;
                    this.order = responseResult;
                    this.onOrderChanged.next(this.order);
                    resolve(responseResult);
                }
                else {
                    reject(singleOrderRes);
                }

            });
        });
    }

    //get single order
    getSingleOrder(id) {
        return new Promise((resolve, reject) => {
            this.commonQueryService.FETCH_ORDER_BY_ID(id).valueChanges.subscribe((singleOrderRes) => {
                if (singleOrderRes && singleOrderRes.data && singleOrderRes.data.allOrders
                    && singleOrderRes.data.allOrders.nodes.length > 0) {
                    resolve(singleOrderRes.data.allOrders.nodes);
                }
                else {
                    reject(singleOrderRes);
                }

            });
        });
    }

    //to update status oof order
    saveOrder(orderId, status) {

        return new Promise((resolve, reject) => {

            var url = this.apiCalls.updateOrder + '&order_id=' + orderId + '&status=' + status;

            this.http.get(url)
                .subscribe((response: any) => {
                    console.log('response', response);
                    resolve(response);

                }, reject);
        });
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/order/order.service.ts